import { render, staticRenderFns } from "./EternityChallengeBox.vue?vue&type=template&id=0d808d9a&scoped=true&"
import script from "./EternityChallengeBox.vue?vue&type=script&lang=js&"
export * from "./EternityChallengeBox.vue?vue&type=script&lang=js&"
import style0 from "./EternityChallengeBox.vue?vue&type=style&index=0&id=0d808d9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d808d9a",
  null
  
)

export default component.exports